/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-04-18 09:43:00
 * @LastEditors: zhangxiaoda zhangxiaoda@nextmar.com
 * @LastEditTime: 2025-05-07 14:26:45
 * @FilePath: /zeelool-nextjs/src/app/test/utils.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import logger from '@/utils/client-logger';
import { EPrescriptionType } from '@/utils/enums/goods';
import { IPrescriptionOptions } from './types';

/**
 * 处方表单上下文接口
 */
interface PrescriptionContext {
  presType: string;
  prescription: {
    is_two_pd: boolean;
  };
  // doublePdMin: number;
  // doublePdMax: number;
  usePd: {
    min_pd: string | number;
    max_pd: string | number;
  };
}

interface OptionValue {
  value: string;
  label: string;
}

/**
 * 返回空处方
 * @returns 空处方对象
 */
export function getEmptyPrescription(): IPrescriptionOptions {
  const emptyPrescription: IPrescriptionOptions = {
    od_sph: '0.00',
    os_sph: '0.00',
    od_cyl: '0.00',
    os_cyl: '0.00',
    od_axis: 'None',
    os_axis: 'None',
    od_add: '0.00',
    os_add: '0.00',
    is_prism: false,
    // 两组PD
    is_two_pd: false,
    pd: '',
    pd_l: '',
    pd_r: '',
    // 是否具有斜视数据
    od_pv: '0.00',
    od_bd: '',
    os_pv: '0.00',
    os_bd: '',
    od_pv_r: '0.00',
    od_bd_r: '',
    os_pv_r: '0.00',
    os_bd_r: '',
  };
  return emptyPrescription;
}

/**
 * 判断处方值是否为空（与默认空处方相等）
 * @param prescription 需要检查的处方对象
 * @returns 如果处方为空返回true，否则返回false
 */
export function isPrescriptionEmpty(prescription: IPrescriptionOptions): boolean {
  const emptyPrescription = getEmptyPrescription();

  // 检查关键值是否都是默认值
  if (
    prescription.od_sph !== emptyPrescription.od_sph ||
    prescription.os_sph !== emptyPrescription.os_sph ||
    prescription.od_cyl !== emptyPrescription.od_cyl ||
    prescription.os_cyl !== emptyPrescription.os_cyl ||
    prescription.od_axis !== emptyPrescription.od_axis ||
    prescription.os_axis !== emptyPrescription.os_axis ||
    prescription.od_add !== emptyPrescription.od_add ||
    prescription.os_add !== emptyPrescription.os_add ||
    prescription.pd !== emptyPrescription.pd ||
    prescription.pd_l !== emptyPrescription.pd_l ||
    prescription.pd_r !== emptyPrescription.pd_r ||
    prescription.od_pv !== emptyPrescription.od_pv ||
    prescription.od_bd !== emptyPrescription.od_bd ||
    prescription.os_pv !== emptyPrescription.os_pv ||
    prescription.os_bd !== emptyPrescription.os_bd ||
    prescription.od_pv_r !== emptyPrescription.od_pv_r ||
    prescription.od_bd_r !== emptyPrescription.od_bd_r ||
    prescription.os_pv_r !== emptyPrescription.os_pv_r ||
    prescription.os_bd_r !== emptyPrescription.os_bd_r
  ) {
    return false;
  }

  return true;
}

export function getOptions(
  type: string,
  context: PrescriptionContext,
  presType?: string,
): string[] | OptionValue[] {
  const validPresType = presType || context.presType;
  const isProgressive = validPresType === EPrescriptionType.PROGRESSIVE;
  // 是否为处方太阳镜
  const isSunglassesPres = validPresType === EPrescriptionType.SUNGLASSES_PRESCRIPTION;
  // 处理双pd范围
  const min_pd = parseInt(String(context.usePd.min_pd || 54), 10);
  const max_pd = parseInt(String(context.usePd.max_pd || 78), 10);
  const doublePdMin = min_pd % 2 === 0 ? min_pd / 2 - 2 : min_pd / 2 - 2.5;
  const doublePdMax = max_pd % 2 === 0 ? max_pd / 2 + 2 : max_pd / 2 + 2.5;
  let min = 0;
  let max = 0;

  switch (type) {
    case 'od_sph':
    case 'os_sph':
      if (
        validPresType === EPrescriptionType.SINGLE_VISION ||
        validPresType === EPrescriptionType.READING_GLASSES
      ) {
        min = -20;
        max = 10;
      } else if (isProgressive) {
        min = -18;
        max = 10;
      } else if (isSunglassesPres) {
        min = -16;
        max = 10;
      } else {
        min = -8;
        max = 6;
      }
      return updateArray(
        getToFix2NumArr(getEqualDiffArrWithSymbol(min, max, 0.25)),
        '0.00',
        'PL',
        'right',
      );
    case 'od_cyl':
    case 'os_cyl':
      // 【ID1007145】太阳镜处方的SPH、CYL可选值范围变更
      min = -6;
      max = 6;
      return updateArray(
        getToFix2NumArr(getEqualDiffArrWithSymbol(min, max, 0.25)),
        '0.00',
        'SPH/DS',
        'right',
      );
    case 'od_axis':
    case 'os_axis':
      return ['None'].concat(getEqualDiffArr(1, 180, 1));
    case 'od_add':
    case 'os_add':
      min = isProgressive ? 0.5 : 0;
      return getToFix2NumArr(getEqualDiffArrWithSymbol(min, 3.5, 0.25));
    case 'pd':
      if (context.prescription.is_two_pd) {
        min = doublePdMin;
        max = doublePdMax;
        return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
      } else {
        min = min_pd;
        max = max_pd;
        return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
      }
    case 'single_pd':
      min = min_pd;
      max = max_pd;
      return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
    case 'pd_l':
    case 'pd_r':
      min = doublePdMin;
      max = doublePdMax;
      return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
    case 'od_pv':
    case 'os_pv':
    case 'od_pv_r':
    case 'os_pv_r':
      return getToFix2NumArr(getEqualDiffArr(0.5, 5, 0.25));
    case 'os_bd_r':
    case 'od_bd_r':
      return ['Up', 'Down'];
    case 'od_bd':
    case 'os_bd':
      return ['In', 'Out'];
    default:
      return [];
  }
}

/**
 * 获取等差数组
 * @param start 起始值
 * @param end 结束值
 * @param difference 差值
 * @returns 等差数组
 */
export function getEqualDiffArr(start: number, end: number, difference: number): string[] {
  if (((end - start) / difference) % 1 > 0) {
    return [];
  }
  return new Array((end - start) / difference + 1).fill(0).map((item, index) => {
    return String(start + difference * index);
  });
}

/**
 * 获取带符号的等差数组
 * @param start 起始值
 * @param end 结束值
 * @param difference 差值
 * @returns 带符号的等差数组
 */
export function getEqualDiffArrWithSymbol(
  start: number,
  end: number,
  difference: number,
): Array<string | number> {
  return getEqualDiffArr(start, end, difference).map((item) => {
    const num = parseFloat(item);
    return num === 0 ? '0' : (num > 0 ? '+' : '') + num;
  });
}

/**
 * 数字小数点后补齐2位
 * @param arr 数字数组
 * @returns 格式化后的数组
 */
export function getToFix2NumArr(arr: Array<string | number>): string[] {
  return arr.map((item) => {
    const a = String(item).split('.');
    a.length === 1 ? a.push('00') : a[1].length === 1 && (a[1] += '0');
    return a.join('.');
  });
}

/**
 * 数组加值
 * @param arr 原数组
 * @param target 目标值
 * @param value 要添加的值
 * @param place 位置（'right'表示在目标值右侧添加）
 * @returns 更新后的数组
 */
export function updateArray(arr: string[], target: string, value: string, place: string): string[] {
  const newArr = [...arr];
  newArr.splice(newArr.indexOf(target) + (place === 'right' ? 1 : 0), 0, value);
  return newArr;
}

export const handlerPrescriptionData = (data: IPrescriptionOptions) => {
  const option = {};
  if (data) {
    const excludeKey = [
      'coating_id',
      'lens_id',
      'pd',
      'pd_l',
      'pd_r',
      'od_axis',
      'os_axis',
      'is_prism',
      'is_two_pd',
    ]; // 不需要转换
    const keys = Object.keys(data);
    for (const key of keys) {
      const value = data[key] as string;
      if (isNaN(parseFloat(value)) || excludeKey.includes(key)) {
        option[key] = `${value}`;
      } else {
        option[key] = `${parseFloat(value).toFixed(2)}`;
      }
    }
    return option;
  }
  return data;
};

/**
 * 联合光度校验
 * @param prescription 处方
 * @param prescriptionType 处方类型
 * @returns 是否有效
 */
export const validateUnion = (
  prescription: IPrescriptionOptions,
  prescriptionType: EPrescriptionType,
) => {
  let isValid = true;
  // 联合光度校验
  const odUnion =
    parseFloat(prescription.od_sph === 'PL' ? '0' : prescription.od_sph) +
    parseFloat(prescription.od_cyl === 'SPH/DS' ? '0' : prescription.od_cyl);
  const osUnion =
    parseFloat(prescription.os_sph === 'PL' ? '0' : prescription.os_sph) +
    parseFloat(prescription.os_cyl === 'SPH/DS' ? '0' : prescription.os_cyl);

  // 各类型镜片的联合光度校验规则
  if (prescriptionType === EPrescriptionType.PROGRESSIVE && (odUnion < -18 || osUnion < -18)) {
    // 渐进镜联合光度规则: -18.00≤SPH+CYL
    isValid = false;
  } else if (
    [EPrescriptionType.SINGLE_VISION, EPrescriptionType.SUNGLASSES_PRESCRIPTION].includes(
      prescriptionType as EPrescriptionType,
    ) &&
    (odUnion < -20 || osUnion < -20)
  ) {
    // 单光镜联合光度校验规则: -20.00≤SPH+CYL
    isValid = false;
  } else if (
    [EPrescriptionType.READING_GLASSES].includes(prescriptionType as EPrescriptionType) &&
    (odUnion + parseFloat(prescription.od_add) < -20 ||
      osUnion + parseFloat(prescription.os_add) < -20)
  ) {
    // 老花镜联合光度校验规则: -20.00≤SPH+ADD+CYL
    isValid = false;
  }

  return isValid;
};

/**
 * 处方识别、从个人中心读取处方、从缓存读取处方得到的处方进行合规校验
 */
export const checkPrescription = (
  prescription: IPrescriptionOptions,
  context: PrescriptionContext,
) => {
  const validKeys = [
    'od_sph',
    'os_sph',
    'od_cyl',
    'os_cyl',
    'od_add',
    'os_add',
    'od_axis',
    'os_axis',
    'pd',
    'pd_l',
    'pd_r',
  ];
  const emptyPrescription = getEmptyPrescription();
  validKeys.forEach((key) => {
    const isSphSpecial = key.includes('sph') && prescription[key] === 'PL';
    const isCylSpecial = key.includes('cyl') && prescription[key] === 'SPH/DS';
    if (isSphSpecial || isCylSpecial) {
      // 特殊值直接通过
      return;
    }
    // 非数字，处理成默认值
    if (Number.isNaN(parseFloat(String(prescription[key])))) {
      prescription[key] = emptyPrescription[key];
    } else {
      // 处方识别出来的数字可能位数不对，这里设置成正确的小数位
      prescription[key] = parseFloat(String(prescription[key])).toFixed(2);
      if (['od_axis', 'os_axis'].includes(key)) {
        prescription[key] = parseFloat(prescription[key]).toFixed(0);
      }
      const optionArr = getOptions(key, context);
      if (!optionArr.includes(prescription[key]) && !optionArr.includes(`+${prescription[key]}`)) {
        prescription[key] = emptyPrescription[key];
      }
    }
  });
  // 把斜视值非标值处理成标准值
  const prismPvKeys = ['od_pv', 'os_pv', 'od_pv_r', 'os_pv_r'];
  const prismBdKeys = ['od_bd', 'os_bd', 'od_bd_r', 'os_bd_r'];
  prismPvKeys.forEach((key) => {
    const optionArr = getOptions(key, context);
    if (!optionArr.includes(String(prescription[key]))) {
      prescription[key] = '0.00';
    }
  });
  prismBdKeys.forEach((key) => {
    const optionArr = getOptions(key, context);
    logger.warn('👀', 'optionArr', key, optionArr, prescription[key]);
    if (!optionArr.includes(String(prescription[key]))) {
      prescription[key] = '';
    }
  });

  // CYL值为0时，忽略AXIS，要在cyl值校验之后再判断axis
  if (prescription.od_cyl == 'SPH/DS' || prescription.od_cyl == '0.00' || !prescription.od_cyl) {
    prescription.od_axis = 'None';
  }
  if (prescription.os_cyl == 'SPH/DS' || prescription.os_cyl == '0.00' || !prescription.os_cyl) {
    prescription.os_axis = 'None';
  }
  // add 必须跟当前的处方类型匹配
  const { od_add, os_add } = handleAddWithPresType({
    od_add: prescription.od_add,
    os_add: prescription.os_add,
    presType: context.presType,
  });
  prescription.od_add = od_add;
  prescription.os_add = os_add;
};

export const handleAddWithPresType = ({
  od_add,
  os_add,
  presType,
}: {
  od_add: string;
  os_add: string;
  presType: string;
}) => {
  // 左右眼都为 0.00 时无须处理
  if (od_add !== '0.00' || os_add !== '0.00') {
    if (['Progressive', 'Bifocal'].includes(presType)) {
      // ②处方类型为Progressive、Bifocal时，仅有一侧的ADD值在可选范围时，OD、OS均使用此ADD值
      // ③处方类型为Progressive、Bifocal时，左右眼ADD值均在可选范围且值不同时，ADD值忽略不填
      if (od_add != os_add) {
        if (od_add === '0.00') {
          od_add = os_add;
        } else if (os_add === '0.00') {
          os_add = od_add;
        } else {
          od_add = '0.00';
          os_add = '0.00';
        }
      }
    } else if (['Single Vision', 'Sunglasses Prescription'].includes(presType)) {
      // ④处方类型为Sunglasses Prescription时，ADD值忽略不填
      od_add = '0.00';
      os_add = '0.00';
    }
  }
  return { od_add, os_add };
};
